<div
	class="drop-zone border border-2 rounded text-center cursor-pointer position-absolute start-50 translate-middle d-flex justify-content-center align-items-center flex-column"
	[class.dragover]="isDragging()"
	(dragover)="onDragOver($event)"
	(dragleave)="onDragLeave($event)"
	(drop)="onDrop($event)"
>
	@if (isDragging()) {
		<p>Tutaj upuść plik</p>
	} @else {
		@if (!!uploadedFile()) {
			<p>
				Załadowano plik: <strong>{{ uploadedFile().name }}</strong>
			</p>
			<button mat-raised-button color="accent" (click)="uploadCSV()">Aktualizuj</button>
		} @else {
			<p>Przeciągnij plik CSV tutaj lub kliknij, aby wybrać</p>
			<button mat-raised-button color="primary" (click)="fileInput.click()">Wybierz plik</button>
		}
	}

	<input type="file" hidden #fileInput (change)="onFileSelected($event)" />
</div>
